import React from "react";
import { cn } from "@/utils/cn";

interface OverlayProps {
  children: React.ReactNode;
  className?: string;
  showOnHover?: boolean;
  interactive?: boolean;
}

export const TopLeft: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
  interactive = false,
}) => (
  <div
    className={cn(
      "absolute top-2 left-2 z-20 flex flex-col gap-1",
      showOnHover && "opacity-0 group-hover/card:opacity-100 transition-opacity",
      className
    )}
    data-interactive={interactive ? "true" : undefined}
  >
    {children}
  </div>
);

export const TopRight: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
  interactive = false,
}) => (
  <div
    className={cn(
      "absolute top-2 right-2 z-20 flex flex-row gap-1 items-start",
      showOnHover && "opacity-0 group-hover/card:opacity-100 transition-opacity",
      className
    )}
    data-interactive={interactive ? "true" : undefined}
  >
    {children}
  </div>
);

export const BottomLeft: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
  interactive = false,
}) => (
  <div
    className={cn(
      "absolute bottom-2 left-2 z-20 flex flex-row gap-2 items-end flex-wrap",
      showOnHover && "opacity-0 group-hover/card:opacity-100 transition-opacity",
      className
    )}
    data-interactive={interactive ? "true" : undefined}
  >
    {children}
  </div>
);

export const BottomRight: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
  interactive = false,
}) => (
  <div
    className={cn(
      "absolute bottom-2 right-2 z-20 flex flex-row gap-2 items-end flex-wrap justify-end",
      showOnHover && "opacity-0 group-hover/card:opacity-100 transition-opacity",
      className
    )}
    data-interactive={interactive ? "true" : undefined}
  >
    {children}
  </div>
);

export const BottomCenter: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
  interactive = false,
}) => (
  <div
    className={cn(
      "absolute bottom-2 left-1/2 transform -translate-x-1/2 z-20",
      showOnHover && "opacity-0 group-hover/card:opacity-100 transition-opacity",
      className
    )}
    data-interactive={interactive ? "true" : undefined}
  >
    {children}
  </div>
);

export const Center: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
  interactive = false,
}) => (
  <div
    className={cn(
      "absolute inset-0 z-20 flex items-center justify-center",
      showOnHover && "opacity-0 group-hover/card:opacity-100 transition-opacity",
      className
    )}
    data-interactive={interactive ? "true" : undefined}
  >
    {children}
  </div>
);
